export default __webpack_public_path__ + "static/media/noto-serif.regular.b975cbe8.ttf";